import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import RiveComponent from "../Shared/RiveComponent";

export default function Banner2(props) {
    const [styleRepeater, setStyleRepeater] = useState({});
    const [imgSrc, setImgSrc] = useState('');
    const [activeChunkIndex, setActiveChunkIndex] = useState(0);
    const [activateFourGamesBaner, setActivateFourGamesBanner] = useState(false);

    const totalBanners = props.activeBanners ? props.activeBanners.length : 0;

    useEffect(() => {
        const currentBanner = props.activeBanners[props.selectedIndex];
        let intervalId;
        let initialTimeout;

        if (currentBanner?.sifra === 'cetiri-igre-dnevno') {
            setActivateFourGamesBanner(true);
            // First determine how many chunks we'll have
            const games = props.newGames || [];
            const chunkCount = Math.ceil(games.length / 2);

            if (chunkCount <= 1) return; // No need for rotation if there's only one chunk
            setActiveChunkIndex(null);

            initialTimeout = setTimeout(() => {
                setActiveChunkIndex(0);

                // Start the rotation after the initial animation
                intervalId = setTimeout(() => {
                    intervalId = setInterval(() => {
                        setActiveChunkIndex(prevIndex => (prevIndex + 1) % chunkCount);
                    }, 2500);
                }, 1000); // Wait for the first animation to complete
            }, 50);
        } else {
            // Reset activeChunkIndex when it's not the 'cetiri-igre-dnevno' banner
            setActiveChunkIndex(0);
            setActivateFourGamesBanner(false);
        }

        // Cleanup on component unmount or when dependencies change
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }

            if (initialTimeout) {
                clearTimeout(initialTimeout);
            }
        };
    }, [props.newGames, props.selectedIndex, props.activeBanners]);

    const fourNewGamesBanner = (game, index) => {
        return (
            <div key={`igra_${index + 1}`} className={`igra igra${index + 1}`}>
                <div className="frame" />
                <picture>
                    <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.avif?c=${casino.config.guiCacheVerzija}`} type="image/avif" />
                    <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.webp?c=${casino.config.guiCacheVerzija}`} type="image/webp" />
                    <img className="okvir" src={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.png?c=${casino.config.guiCacheVerzija}`} alt="Game border" />
                </picture>
                <NavLink
                    className="link"
                    onClick={() => createGoogleTagEvent(game)}
                    to={{
                        pathname: '/game/' +
                            props.brands[game.bID].nameNormalizirano +
                            '/' + casino.utils.normalizeString(game.n),
                        query: {
                            // GamePosition podaci, HizmanB
                            PageName: "Home",
                            GamePosition: index + 1,
                            PositionType: "banner",
                            BannerName: "cetiri-igre-dnevno",
                            BannerPosition: props.selectedIndex + 1,
                            IsIcon: false,
                        }

                    }}
                >
                    <div className="new-button" />
                    <img className="gumb" src='content/Images/Bonusi/btn_play_with_money_a2_smaller_blue.png' alt="Play button" />
                    <img
                        className="slika"
                        src={casino.config.gameImagesUrl +
                            props.brands[game.bID].nameNormalizirano +
                            "/" + casino.utils.normalizeString(game.n) +
                            (casino.config.canIUseWebP ? '.webp' : '.jpeg')}
                        alt="Game thumbnail"
                    />
                </NavLink>
            </div>
        )
    }

    const renderGamesBanner = (games) => {
        // Create chunks of 2 pairs out of 4 game objects in the list
        const chunks = [];
        for (let i = 0; i < games.length; i += 2) {
            chunks.push(games.slice(i, i + 2));
        }

        return chunks.map((chunk, chunkIndex) => {
            // Use the activeChunkIndex state to determine which chunk is active
            const isActive = chunkIndex === activeChunkIndex;

            return (
                <div key={`chunk-${chunkIndex}`} className={`games-box ${isActive ? 'active' : ''}`}>
                    {chunk.map((game, index) => fourNewGamesBanner(game, chunkIndex * 2 + index))}
                </div>
            );
        });
    };

    useEffect(() => {
        if (props.backgroundRepeaterImageUrl) {
            setImgSrc(casino.config.gameImagesUrl + props.brands[props.igra1.bID].nameNormalizirano + '/' + casino.utils.normalizeString(props.igra1.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg'));
            setStyleRepeater({ backgroundImage: imgSrc });
        }
    }, []);

    function focusTab(name) {
        props.showKategorijaFn(name);
    }

    function showInfoPopUp(value) {
        props.showPopUpFn(value);
    }

    function getJackpot(value) {
        let suma = 0;
        props.jackpots.map(x => {
            if (x.providerJackpotID == value || value == 99)
                suma += x.iznos;
        })

        if (suma > 0)
            return casino.utils.numberToString(suma);

        return "-";
    }
    function getBiggestJackpot() {
        if (props && props.jackpots && props.jackpots.length) {
            let value = casino.utils.numberWithCurrencyFromated(props.jackpots[0].iznos, props.jackpots[0].valuta);
            return value;
        }
        return "-";
    }
    function getBiggestJackpotNumber() {
        if (props && props.jackpots && props.jackpots.length) {
            return props.jackpots[0].iznos;
        }
        return 0;
    }
    const createGoogleTagEvent = (game) => {
        let kategorijeArray = [];

        Object.keys(game.kt).forEach(key => {
            const filterKategorija = props.categories.find(x => x.id == key);
            if (filterKategorija) kategorijeArray.push(filterKategorija.name);
        });

        casino.utils.createGoogleTagManagerEvent({
            'event': 'game_click',
            'game_name': game.n,
            'game_provider': props.brands[game.bID].name,
            'game_type': kategorijeArray ? kategorijeArray.join() : '',
            'jackpot': game.jp ? 'yes' : 'no',
            'jackpot_amount': game.jp ? game.jp : 0,
            'gameId': game.id
        });
    }
    return (
        <div className="banner--content">
            <div className="banner--bg-container">
                <div className="banner--repeater " >
                    {props.backgroundRepeaterImageUrl && <img src={imgSrc}></img>}
                    {props.igraDana && props.sifra == 'igra-dana' && <img src={casino.config.gameImagesUrl + props.brands[props.igraDana.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.igraDana.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg')}></img>}
                </div>
                <div className="banner--repeater2 "></div>
                <div className="banner--background "></div>
                <div className="banner--mask mobile-hidden "></div>
                <div className="banner--background-2"></div>
            </div>
            <div className="banner--foreground">
                {props.gifImage && <img className={"banner--gif--image " + props.sifra} src={props.gifImage} />}
                {props.rive && <div className="rive-container"><RiveComponent lazyLoad={true} cacheBust={`c=${casino.config.guiCacheVerzija}`} src={props.rive} stateMachines={props.riveStateMachineName} useOffscreenRenderer={true} playRequest={true} width={props.riveWidth} height={props.riveHeight} disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }} /></div>}
                {props.rive2 && <div className="rive-container-2"><RiveComponent lazyLoad={true} cacheBust={`c=${casino.config.guiCacheVerzija}`} src={props.rive2} stateMachines={props.riveStateMachineName2} useOffscreenRenderer={true} playRequest={true} width={props.riveWidth2} height={props.riveHeight2} disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }} /></div>}
                {props.iframe && props.index === props.selectedIndex &&     
                    <iframe src={props.iframe} className="i-frame" key={props.selectedIndex} />
                }
                {props.videoURL && <div className="video-player-container">
                    <video
                        autoPlay={true}
                        controls={false}
                        disablePictureInPicture={true}
                        disableRemotePlayback={true}
                        loop={true}
                        muted={true}
                        src={props.videoURL}
                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                </div>}
                <div className={(props.gifImage ? " " : "banner--image ") + props.sifra}>
                    {props.jackpotProviderId && <div className="jackpotbanner " >
                        {getJackpot(props.jackpotProviderId).toString().split('').map(
                            (x, i) => <span key={i} className={x == '.' || x == ',' ? 'not-number' : 'number'}>{x}</span>
                        )}
                        <span className="kn small-mobile-hidden">kn <span className="kruna"></span></span>
                    </div>}

                    {props.igra1 && !props.igra2 && <div className="igra igra1">
                        <picture>
                            <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/1x_dnevno_background_okvir.avif?c=${casino.config.guiCacheVerzija}`} type="image/avif" />
                            <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/1x_dnevno_background_okvir.webp?c=${casino.config.guiCacheVerzija}`} type="image/webp" />
                            <img className="okvir" src={`${casino.config.casinoCDNImagesUrl}/Banners/1x_dnevno_background_okvir.png?c=${casino.config.guiCacheVerzija}`} alt="" />
                        </picture>
                        <img className="slika" src={casino.config.gameImagesUrl + "/" + props.igra1.imageName + (casino.config.canIUseWebP ? '.webp' : '.jpeg')}></img>
                    </div>}

                    {props.igraDana && props.sifra == 'igra-dana' && <div className="igra igra-dana">
                        <picture>
                            <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/SS_1x_igra_dnevno_sprite@2x.avif?c=${casino.config.guiCacheVerzija}`} type="image/avif" />
                            <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/SS_1x_igra_dnevno_sprite@2x.webp?c=${casino.config.guiCacheVerzija}`} type="image/webp" />
                            <img className="okvir" src={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/SS_1x_igra_dnevno_sprite@2x.png?c=${casino.config.guiCacheVerzija}`} alt="" />
                        </picture>
                        <img className="slika" src={casino.config.gameImagesUrl + props.brands[props.igraDana.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.igraDana.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg')}></img>
                    </div>}

                    {activateFourGamesBaner && props.newGames && renderGamesBanner(props.newGames)}

                    {props.firstPerson1 && props.firstPerson2 && <div className="igra firstPerson1">
                        <NavLink className="link" to={{ pathname: '/game/evolution/first-person-blackjack' }}>
                            <img className="slika" src={props.firstPerson1}></img>
                        </NavLink>
                    </div>}

                    {props.firstPerson2 && <div className="igra firstPerson2">
                        <NavLink className="link" to={{ pathname: '/game/evolution/first-person-roulette' }}>
                            <img className="slika" src={props.firstPerson2}></img>
                        </NavLink>
                    </div>}

                    {props.gameId2 &&
                        <NavLink className={props.buttonClassName + ' btn medium fill margin-right-small '} to={{ pathname: '/', query: { game: props.gameId2 } }}>
                            {props.gameIdButtonText || props.buttonText}
                        </NavLink>}


                    {props.link3 &&
                        <NavLink className={props.buttonClassName + ' btn medium fill '} to={props.link3}>
                            {props.buttonText}
                        </NavLink>}

                    {props.mIgra1 &&
                        <div>
                            <div className="maradona-text"></div>
                            <NavLink to={{ pathname: '/game/' + props.brands[props.mIgra1.bID].nameNormalizirano + '/' + casino.utils.normalizeString(props.mIgra1.n) }}>
                                <div className="igra igra1">
                                    <picture>
                                        <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/2xdnevno/img_game_gradient_border_mobile.avif?c=${casino.config.guiCacheVerzija}`} type="image/avif" />
                                        <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/2xdnevno/img_game_gradient_border_mobile.webp?c=${casino.config.guiCacheVerzija}`} type="image/webp" />
                                        <img className="okvir" src={`${casino.config.casinoCDNImagesUrl}/Banners/IgraDana/2xdnevno/img_game_gradient_border_mobile.png?c=${casino.config.guiCacheVerzija}`} alt="" />
                                    </picture>
                                    <img className="slika" src={casino.config.gameImagesUrl + props.brands[props.mIgra1.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.mIgra1.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg')}></img>
                                </div>
                            </NavLink>
                            <NavLink to={{ pathname: '/game/' + props.brands[props.mIgra2.bID].nameNormalizirano + '/' + casino.utils.normalizeString(props.mIgra2.n) }}>
                                <div className="igra igra2">
                                    <picture>
                                        <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.avif?c=${casino.config.guiCacheVerzija}`} type="image/avif" />
                                        <source srcSet={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.webp?c=${casino.config.guiCacheVerzija}`} type="image/webp" />
                                        <img className="okvir" src={`${casino.config.casinoCDNImagesUrl}/Banners/2xdnevno/img_game_gradient_border_mobile.png?c=${casino.config.guiCacheVerzija}`} alt="" />
                                    </picture>
                                    <img className="slika" src={casino.config.gameImagesUrl + props.brands[props.mIgra2.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.mIgra2.n) + (casino.config.canIUseWebP ? '.webp' : '.jpeg')}></img>
                                </div>
                            </NavLink>
                        </div>
                    }
                </div>
                {props.bannerImage2 && <div className="banner--image bannerImage2" />}
                {props.bannerImage3 && <div className="banner--image bannerImage3" />}
                {props.bannerImage4 && <div className="banner--image bannerImage4" />}
                {props.bannerImage5 && <div className="banner--image bannerImage5" />}

                {props.imageRight && <div className="banner--image-right"></div>}


                {props.titleText && <div className="banner--text banner--title">
                    <div className={props.notCenterVerticalyText ? "as-inline-block" : "as-inline-block  center-verticaly"}>
                        {props.imageTitle && <div className="banner--image-title"></div>}
                        <span className="as-block text-white text-xlarge text-xbold text-shadow">{props.titleText} </span>
                    </div>
                </div>}

                <div className="banner--text">
                    <div className={props.notCenterVerticalyText ? "as-inline-block" : "as-inline-block  center-verticaly"}>
                        <span className="as-block text-white text-large   text-shadow">{props.smallText}</span>
                        <span className="as-block text-white text-xlarge text-xbold text-shadow">{props.bigText}</span>

                        {props.najveciJackpot && <div className="jackpot-iznos">
                            <div className={"game-icon-" + props.sifra}></div>
                            <div className={getBiggestJackpotNumber() >= 10000000 ? "iznos large" : "iznos"}>
                                {getBiggestJackpot()}
                                {/* {casino.utils.switchEurToKn(getBiggestJackpot()).toString().split('').map(
                                (x, i) => <span key={i} className={x == '.' || x == ',' ? 'not-number' : 'number'}>{x}</span>
                            )} */}
                                <span className="kruna"></span>
                            </div>
                        </div>}

                        {props.bigText2 ?
                            <span className="as-block text-white text-xlarge text-xbold text-shadow">{props.bigText2}</span> : null}

                        <span className="as-block text-white text-large  text-shadow">{props.smallText2}</span>

                        {props.smallText3 ?
                            <span className="as-block text-white text-large  text-shadow">{props.smallText3}</span> : null}

                        {props.bigTextBottom ?
                            <span className="text-banner-bottom as-block text-white text-large text-xbold text-shadow">{props.bigTextBottom}</span> : null}

                        <div className="margin-top"></div>

                        {props.sifra == 'igra-dana' && props.igraDana ?
                            <NavLink className={props.buttonClassName + ' btn medium fill margin-right-small '} to={{ pathname: '/', query: { game: casino.utils.normalizeString(props.igraDana.n) } }}>
                                {props.gameIdButtonText || props.buttonText}
                            </NavLink>
                            : null
                        }

                        {props.gameId ?
                            <NavLink className={props.buttonClassName + ' btn medium fill margin-right-small '} to={{ pathname: '/', query: { game: props.gameId } }}>
                                {props.gameIdButtonText || props.buttonText}
                            </NavLink>
                            : null
                        }

                        {props.link && !props.linkAbsolute ?
                            <NavLink className={props.buttonClassName + ' btn medium fill '} to={props.link}>
                                {props.buttonText}
                            </NavLink>
                            : null
                        }

                        {props.link && props.linkAbsolute ?
                            <a className={props.buttonClassName + ' btn medium fill '} href={props.link} onClick={props.onClick ? props.onClick : null}>
                                {props.buttonText}
                            </a>
                            : null
                        }

                        {props.link2 && !props.link2Absolute ?
                            <NavLink className={props.buttonClassName + ' btn medium fill '} to={props.link2}>
                                {props.buttonText2}
                            </NavLink>
                            : null
                        }

                        {props.link2 && props.link2Absolute ?
                            <a className={props.buttonClassName + ' btn medium fill '} href={props.link2} onClick={props.onClick2 ? props.onClick2 : null}>
                                {props.buttonText2}
                            </a>
                            : null
                        }

                        {props.tab ?
                            <button className={props.buttonClassName + ' btn medium fill'} onClick={() => focusTab(props.tab)}>
                                {props.buttonText}
                            </button>
                            : null
                        }

                        {props.popUp ?
                            <button className={props.buttonClassName + ' btn medium fill'} onClick={() => showInfoPopUp(true)}>
                                {props.buttonText}
                            </button>
                            : null
                        }

                        {(props.imgButton1 || props.imgButton2) &&
                            <div className="image-buttons">
                                {props.imgButton1 &&
                                    <NavLink to={{ pathname: '/', query: { game: props.imgButton1 } }}>
                                        <div className="image-button roulette"></div>
                                    </NavLink>
                                }
                                {props.imgButton2 &&
                                    <NavLink to={{ pathname: '/', query: { game: props.imgButton2 } }}>
                                        <div className="image-button blackjack"></div>
                                    </NavLink>
                                }
                            </div>
                        }
                        <div className="margin-top margin-bottom">&nbsp;</div>
                        <div className="margin-top margin-bottom">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
    )
}